import Closed from "./Closed";
export default Closed;
